// 中国标准时间转化为年月日时分秒格式
export function fnCSTToYmd(date, opt) {
  // defhms-"00:00:00", "23:59:59"
  function fnAddZero(params) {
    return (params = params < 10 ? '0' + params : params);
  }
  let y = date.getFullYear(),
    m = date.getMonth() + 1,
    d = date.getDate(),
    h = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds();
  if (opt && opt.tag) {
    return y + '-' + fnAddZero(m) + '-' + fnAddZero(d);
  } else if (opt && opt.defhms) {
    return y + '-' + fnAddZero(m) + '-' + fnAddZero(d) + ' ' + opt.defhms;
  } else {
    return (
      y +
      '-' +
      fnAddZero(m) +
      '-' +
      fnAddZero(d) +
      ' ' +
      fnAddZero(h) +
      ':' +
      fnAddZero(minute) +
      ':' +
      fnAddZero(second)
    );
  }
}

// 郑亚杰start
//获取今天0点到现在的毫秒数
function getMsecond() {
  var now = new Date().getTime();
  var zero = new Date(
    new Date().getFullYear() + '/' + (new Date().getMonth() / 1 + 1) + '/' + new Date().getDate(),
  ).getTime();
  // console.log(now - zero);
  return now - zero;
}
export const adPickerOptions = {
  disabledDate(time) {
    return time.getTime() > Date.now();
  },
  shortcuts: [
    {
      text: '今天',
      quick: true,
      onClick(picker) {
        var date = new Date().getFullYear() + '/' + (new Date().getMonth() / 1 + 1) + '/' + new Date().getDate();
        if (picker) {
          picker.$emit('pick', [new Date(date), new Date()]);
        } else {
          return [new Date(date), new Date()];
        }
      },
    },
    {
      text: '昨天',
      quick: true,
      onClick(picker) {
        var date = new Date().setTime(new Date().getTime() - (3600 * 1000 * 24 + getMsecond()));
        var date1 = new Date().setTime(new Date().getTime() - getMsecond() - 1);
        if (picker) {
          picker.$emit('pick', [new Date(date), new Date(date1)]);
        } else {
          return [new Date(date), new Date(date1)];
        }
      },
    },
    {
      text: '近3天',
      quick: true,
      onClick(picker) {
        var end = new Date();
        var start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * (24 * (3 - 1)));
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    {
      text: '近7天',
      quick: true,
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * (24 * (7 - 1)));
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    {
      text: '本周',
      onClick(picker) {
        let now = new Date(),
          d = now.getDay(),
          start,
          end;
        start = new Date(now.getTime() - getMsecond() - 3600 * 24 * d * 1000);
        if (picker) {
          picker.$emit('pick', [start, new Date()]);
        } else {
          return [start, new Date()];
        }
      },
    },
    {
      text: '本月',
      quick: true,
      onClick(picker) {
        let now = new Date(),
          y = now.getFullYear(),
          m = now.getMonth(),
          start = new Date(y, m, 1),
          end = new Date(y, m + 1, 0);
        if (picker) {
          picker.$emit('pick', [start, new Date()]);
        } else {
          return [start, new Date()];
        }
      },
    },
    {
      text: '上周',
      onClick(picker) {
        let now = new Date(),
          d = now.getDay(),
          start,
          end;
        start = new Date(now.getTime() - getMsecond() - 3600 * 24 * (d + 7) * 1000);
        end = new Date(now.getTime() - getMsecond() - 3600 * 24 * d * 1000);
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    {
      text: '上月',
      onClick(picker) {
        let now = new Date(),
          y = now.getFullYear(),
          m = now.getMonth(),
          start = new Date(y, m - 1, 1),
          end = new Date(y, m, 0);
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    // {
    //   text: "近5天",
    //   quick:true,
    //   onClick(picker) {
    //     var end = new Date();
    //     var start = new Date();
    //     start.setTime(start.getTime() - 3600 * 1000 * (24 * (5 - 1)));
    //     if(picker){
    //       picker.$emit('pick', [start, end]);
    //     }else{
    //       return [start, end]
    //     }
    //   }
    // },
    // {
    //   text: '上月+本月',
    //   quick:true,
    //   onClick(picker) {
    //     let now = new Date(),
    //         y = now.getFullYear(),
    //         m = now.getMonth(),
    //         start = new Date(y, m - 1, 1)
    //     const end = new Date();
    //     if(picker){
    //       picker.$emit('pick', [start, end]);
    //     }else{
    //       return [start, end]
    //     }
    //   }
    // },
    {
      text: '近30天',
      quick: true,
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * (24 * (30 - 1)));
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    {
      text: '近90天',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * (24 * (90 - 1)));
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
    {
      text: '近180天',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * (24 * (30 * 6 + 1)));
        if (picker) {
          picker.$emit('pick', [start, end]);
        } else {
          return [start, end];
        }
      },
    },
  ],
};
